import {applyTheme, DEFAULT_THEME, initTheme, THEME_LIST} from '@/utils/theme'

const state = {
  current: localStorage.getItem('app_theme') || DEFAULT_THEME,
  options: THEME_LIST,
}

const mutations = {
  SET_THEME(state, theme) {
    state.current = applyTheme(theme)
  },
  INIT_THEME(state) {
    state.current = initTheme()
  },
}

const actions = {
  setTheme({commit}, theme) {
    commit('SET_THEME', theme)
  },
  initTheme({commit}) {
    commit('INIT_THEME')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
